import { observable, computed, action } from "mobx";
import Autobind from "autobind-decorator";
import RootStore from "./rootStore";
/**
 * @class SynchronizationStore
 * @description 요청에 따른 Study 목록을 반환
 */
@Autobind
class MeasureToolStore {
  _rootStore: RootStore; /// rootStore 객체. 다른 Store를 연계할 때 사용

  @observable
  _activeToolName = "none";

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }

  getActiveToolName() {
    return this._activeToolName;
  }

  setActiveToolName(toolName: string) {
    this._activeToolName = toolName;
  }
}

export default MeasureToolStore;
